class ProductCardSwatches {
  constructor() {
    this.cards = document.querySelectorAll('[data-product-card]');
    this.initializeSwatches();
  }

  initializeSwatches() {
    this.cards.forEach(card => {
      const swatches = card.querySelectorAll('[data-swatch-variant]');
      const productImage = card.querySelector('[data-product-card-image]');
      
      if (!productImage) return;
      
      const defaultImageData = this.getImageData(productImage);

      swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', () => {
          const variantImage = swatch.getAttribute('data-variant-image');
          if (variantImage) {
            this.updateProductImage(productImage, variantImage);
          }
        });

        // Optional click handler for mobile devices
        swatch.addEventListener('click', (e) => {
          const variantImage = swatch.getAttribute('data-variant-image');
          if (variantImage) {
            e.preventDefault();
            this.updateProductImage(productImage, variantImage);
          }
        });
      });

      // Restore default image when mouse leaves the swatch container
      const swatchContainer = card.querySelector('.card-swatch-container');
      if (swatchContainer) {
        swatchContainer.addEventListener('mouseleave', () => {
          this.restoreDefaultImage(productImage, defaultImageData);
        });
      }
    });
  }

  getImageData(imageElement) {
    if (!imageElement) return null;
    return {
      src: imageElement.src,
      srcset: imageElement.srcset,
      sizes: imageElement.sizes
    };
  }

  updateProductImage(imageElement, variantImageUrl) {
    if (!imageElement || !variantImageUrl) return;

    // Generate srcset for the variant image
    const widths = [165, 360, 533, 720, 940, 1066];
    const srcset = widths
      .map(width => {
        const variantSrc = variantImageUrl.replace(/\.(jpg|jpeg|png|gif|webp)/, `_${width}x.$1`);
        return `${variantSrc} ${width}w`;
      })
      .join(', ');

    imageElement.srcset = srcset;
    imageElement.src = variantImageUrl;
  }

  restoreDefaultImage(imageElement, defaultImageData) {
    if (!imageElement || !defaultImageData) return;
    
    imageElement.src = defaultImageData.src;
    if (defaultImageData.srcset) imageElement.srcset = defaultImageData.srcset;
    if (defaultImageData.sizes) imageElement.sizes = defaultImageData.sizes;
  }
}

// Initialize card swatches
document.addEventListener('DOMContentLoaded', () => {
  new ProductCardSwatches();
});